<azavista3-public-page-container *ngIf="isLoaded">
    <div class="login-wrapper aza-pa-flex-row aza-pa-flex-item-align-center aza-pa-content-center">
        <mat-card appearance="outlined" class="login-card mat-elevation-z8 aza-pa-padding">
            <mat-card-title>{{translations.LOGIN | translate}}</mat-card-title>
            <mat-card-subtitle>
                {{translations.DONT_HAVE_ACCOUNT_YET | translate }}
                <a href="{{signUpUrl}}" class="az-small-text login-signup-button">{{translations.SIGNUP_NOW | translate}}</a>
            </mat-card-subtitle>
            <div class="login-form-container aza-pa-flex-column aza-pa-flex-item-align-center">

                <form (ngSubmit)="onLogin()">
                    <div class="aza-pa-flex-column">
                        <mat-form-field class="aza-pa-full-width" appearance="outline">
                            <mat-label><span translate>EMAIL_ADDRESS</span></mat-label>
                            <input [(ngModel)]="email" autofocus matInput autocomplete="username" type="email"
                                name="email">
                        </mat-form-field>
                        <mat-form-field class="aza-pa-full-width" appearance="outline">
                            <mat-label><span translate>PASSWORD</span></mat-label>
                            <input [(ngModel)]="password" autocomplete="current-password" matInput
                                [type]="isRevealPassword ? 'text' : 'password'" name="password">
                            <mat-icon
                                (click)="toggleRevealPassword()"
                                matSuffix
                                color="primary"
                                class="material-icons-outlined"
                            >{{isRevealPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                        <mat-error *ngIf="hasError"><span translate>INVALID_USERNAME_OR_PASSWORD</span></mat-error>
                        <div class="aza-pa-flex-row aza-pa-flex-item-align-center login-form__option">
                            <mat-checkbox color="primary"><span translate>STAY_SIGNED_IN</span></mat-checkbox>
                            <p class="hint-text">
                                <a routerLink="/reset-password" class="az-small-text login-forgot-password">
                                    {{translations.FORGOT_PASSWORD | translate}}
                                </a>
                            </p>
                        </div>
                        <button class="login-button aza-pa-full-width" mat-raised-button color="primary"><span
                            translate>LOGIN</span></button>
                    </div>
                </form>

                <div class="aza-pa-flex-row aza-pa-margin-block">
                    <div class="dummy-divider"></div>
                    <span translate>OR</span>
                    <div class="dummy-divider"></div>
                </div>
                <div class="social-login-btns">
                    <a [href]="corporateLoginUrl" mat-flat-button>
                        <mat-icon>location_city</mat-icon>
                        {{translations.COMPANY_SIGN_IN | translate}}
                    </a>
                    <a [href]="googleLoginUrl" mat-flat-button>
                        <img src="assets/img/Google__G__logo.svg" alt="Google"/>
                    </a>
                    <a [href]="microsoftLoginUrl" mat-flat-button>
                        <img src="assets/img/Microsoft_icon.svg" alt="Google"/>
                    </a>
                </div>


            </div>
        </mat-card>
    </div>

    <button id="libraria-chatbot-button" mat-fab color="primary">
        <mat-icon class="az-gray-text material-icons-outlined">help_outline</mat-icon>
    </button>

</azavista3-public-page-container>
